export const getDateRange = (filterValue, startDateBetween, endDateBetween) => {
  const today = new Date();
  let startDate, endDate;

  switch (filterValue) {
    case "Today":
      startDate = new Date(today.setHours(0, 0, 0, 0)).toISOString();
      break;

    case "ThisWeek": {
      const firstDayOfWeek = new Date(
        today.setDate(today.getDate() - today.getDay()),
      );
      startDate = new Date(firstDayOfWeek.setHours(0, 0, 0, 0)).toISOString();
      break;
    }

    case "ThisMonth":
      startDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        1,
      ).toISOString();
      break;

    case "7days":
      startDate = new Date(today.setDate(today.getDate() - 7)).toISOString();
      break;

    case "LastMonth":
      startDate = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1,
      ).toISOString();
      endDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        0,
        23,
        59,
        59,
        999,
      ).toISOString();
      break;

    case "30days":
      startDate = new Date(today.setDate(today.getDate() - 30)).toISOString();
      break;

    case "90days":
      startDate = new Date(today.setDate(today.getDate() - 90)).toISOString();
      break;

    case "ThisYear":
      startDate = new Date(today.getFullYear(), 0, 1).toISOString();
      break;

    case "LastYear": {
      const lastYear = today.getFullYear() - 1;
      startDate = new Date(lastYear, 0, 1).toISOString();
      endDate = new Date(lastYear, 11, 31, 23, 59, 59, 999).toISOString();
      break;
    }

    case "allData":
      startDate = undefined;
      break;

    case "Between":
      startDate = startDateBetween || undefined;
      endDate = endDateBetween || undefined;
      break;

    default:
      throw new Error("Invalid filter value");
  }

  return { startDate, endDate };
};
